import React from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from '@browsing/components';

import HeaderWrapper from '@client/components/header/headerWrapper';

type Props = React.ComponentProps<typeof HeaderWrapper>;

const LoadableStaticHeader = loadable(
    () => import(/* webpackChunkName: "static-header" */ './staticHeaderContainer'),
);

const Header = (props: Props) => {
    return (
        <ErrorBoundary fallbackUI={LoadableStaticHeader} componentName="header">
            <HeaderWrapper {...props} />
        </ErrorBoundary>
    );
};

export default Header;
